import { Button } from "@mui/material"
import React from "react"
import { customPalette } from "../../../theme"

interface IProps {
  onClick?(): void
}

export function SupportContactButton({ onClick }: Readonly<IProps>): React.JSX.Element {
  return (
    <Button
      onClick={onClick}
      sx={{
        color: customPalette.white,
        textTransform: "none",
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}>
      🛟Besoin d'aide ?
    </Button>
  )
}
